const ANSWER_TYPES = {
	SAVE_EDITION: 'ANSWERS/SAVE',
	SAVE_USER_COURSE_ANSWERS: 'ANSWERS/SAVE_USER_COURSE_ANSWERS',
	SAVE_USER_SECTION_ANSWERS: 'ANSWERS/SAVE_USER_SECTION_ANSWERS',
	UPDATE_USER_COURSE_ANSWERS: 'ANSWERS/UPDATE_USER_COURSE_ANSWERS',
	UPDATE_USER_SECTION_ANSWERS: 'ANSWERS/UPDATE_USER_SECTION_ANSWER',
};

export default ANSWER_TYPES;
